import type { ReactNode, RefObject } from "react";
import type { PillSearchScope } from "./pill-search-records";
import { PillSearchResults } from "./pill-search-results";
import { usePillSearch } from "./use-pill-search";
import styles from "../account-pill.module.css";

/** The menu remains mounted until typing starts; search reads are enabled by the query. */
export function PillSearch({
  input,
  label,
  placeholder,
  scope,
  member,
  all,
  onNavigate,
  children,
}: {
  input: RefObject<HTMLInputElement | null>;
  label: string;
  placeholder: string;
  scope: PillSearchScope;
  member: boolean;
  all: ((query: string) => string) | null;
  onNavigate: (href: string) => void;
  children: ReactNode;
}) {
  const {
    resultList,
    query,
    q,
    groups,
    ready,
    allHref,
    active,
    setActive,
    changeQuery,
    onKeyDown,
    onSubmit,
  } = usePillSearch({ input, scope, member, all, onNavigate });

  return (
    <>
      <search>
        <form onSubmit={onSubmit}>
          <input
            ref={input}
            type="search"
            aria-label={label}
            placeholder={placeholder}
            enterKeyHint="search"
            autoComplete="off"
            className={styles.field}
            value={query}
            onChange={(event) => changeQuery(event.target.value)}
            onKeyDown={onKeyDown}
            onFocus={() => setActive(-1)}
          />
        </form>
      </search>
      {q === "" ? (
        children
      ) : (
        <PillSearchResults
          resultList={resultList}
          query={q}
          groups={groups}
          ready={ready}
          allHref={allHref}
          active={active}
          setActive={setActive}
          onNavigate={onNavigate}
          onKeyDown={onKeyDown}
        />
      )}
    </>
  );
}
